import styled from 'styled-components';

export const TopicContainer = styled.div`
  border: solid 1px #dfdfdf;
  color: #1e1e1e;
  border-bottom: none;
`;
